export class PathPartitionsTimestamp {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "columnName",
            "baseName": "columnName",
            "type": "string",
            "format": ""
        },
        {
            "name": "granularity",
            "baseName": "granularity",
            "type": "PathPartitionsTimestampGranularity",
            "format": ""
        },
        {
            "name": "yearColumn",
            "baseName": "yearColumn",
            "type": "string",
            "format": ""
        },
        {
            "name": "monthColumn",
            "baseName": "monthColumn",
            "type": "string",
            "format": ""
        },
        {
            "name": "dayColumn",
            "baseName": "dayColumn",
            "type": "string",
            "format": ""
        },
        {
            "name": "hourColumn",
            "baseName": "hourColumn",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PathPartitionsTimestamp.attributeTypeMap;
    }
    constructor() {
    }
}
